module.exports = __webpack_public_path__ + "static/media/Gotham-Book.03dfaa3b.otf";